<template>
  <div>
    <vs-alert :active="'true'" color="warning" icon="error_outline" class="mb-2 md:mb-4 single-line-alert" v-if="displayCardWarning">
      <p>Warning: a seller disclosure statement has already been ordered on this agreement (you can proceed with an additional order if required)</p>
    </vs-alert>
    <vs-row v-if="displayHeader">
      <vs-col class="mb-10">
        <p v-if="displayType == 'newRequest' && sdsDetails.descriptionForNewPayLater" v-html="sdsDetails.descriptionForNewPayLater"></p>
        <p v-else-if="displayType == 'topUp' && sdsDetails.descriptionForTopUp" v-html="sdsDetails.descriptionForTopUp"></p>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col>
        <h6 class="mb-4">Confirm required services (all prices inc GST)</h6>
        <div class="grid sm:grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-10 my-6 ds-wrapper sds-wrapper">
          <div>
            <div v-for="(data, index) in groupSds" :key="index" class="mb-2">
              <vs-radio v-if="data.required" v-model="data.enabled" :vs-value="true" name="options" @change="handleServiceChange('sds')">
                <div class="item-label-content">
                  <span>{{ data.label }}</span>
                  <span>{{ formatCurrency(data.cost) }}</span>
                </div>
              </vs-radio>
              <vs-checkbox class="ml-8" v-else v-model="data.enabled" :vs-value="data.enabled" name="options" v-validate="data.required ? 'required' : ''" @change="validateItems(index, data.group)" :disabled="data.disableItem">
                <div class="item-label-content">
                  <span>{{ data.label }}</span>
                  <span>{{ formatCurrency(data.cost) }}</span>
                </div>
              </vs-checkbox>
            </div>
            <div class="sds-total" v-if="selectedGroup == 'sds' && totalAmount > 0">
              <hr class="my-2" />
              <div class="flex justify-end">
                <p class="mr-6">Total cost (inc GST):</p>
                <p>{{ formatCurrency(totalAmount) }}</p>
              </div>
            </div>
          </div>
          <div class="md:pl-16">
            <div v-for="(data, index) in groupConveyancing" :key="index" class="mb-2">
              <vs-radio v-if="data.required" v-model="data.enabled" :vs-value="true" name="options" @change="handleServiceChange('conveyancing')">
                <div class="item-label-content">
                  <span>{{ data.label }}</span>
                  <span>{{ formatCurrency(data.cost) }}</span>
                </div>
              </vs-radio>
              <vs-checkbox v-else v-model="data.enabled" :vs-value="data.enabled" name="options" v-validate="data.required ? 'required' : ''" @change="validateItems(index, data.group)" :disabled="data.disableItem">
                <div class="item-label-content">
                  <span>{{ data.label }}</span>
                  <span>{{ formatCurrency(data.cost) }}</span>
                </div>
              </vs-checkbox>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    displayHeader: { type: Boolean, default: true },
    displayType: { type: String },
    sdsOrders: { type: Array },
  },

  data() {
    return {
      groupConveyancing: [],
      groupSds: [],
      sdsDetails: {},
      selectedGroup: "sds",
      selectedItems: [],
      totalAmount: 0,
    };
  },

  methods: {
    ...mapActions("setting", ["fetchSetting"]),

    async getSellerDisclosureStatementSetting() {
      await this.fetchSetting("sellerDisclosureStatement").then((res) => {
        this.sdsDetails = res.data.data;

        if (this.sdsDetails.items && this.sdsDetails.items.length) {
          this.sdsDetails.items = this.sdsDetails.items.map((item) => {
            return {
              ...item,
              enabled: false ,
              disableItem: !item.required
            };
          });

          this.groupSds = this.sdsDetails.items.filter(item => item.group == 1);
          this.groupConveyancing = this.sdsDetails.items.filter(item => item.group == 2);
        }

        this.$emit("setSdsSettings", this.sdsDetails);
      }).catch((ex) => {
        this.$vs.notify({
          title: "Error",
          text: "Error fetching seller disclosure statement setting",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
    },

    async clearErrors() {
      this.errors.clear();
    },

    resetSdsOrderFields() {
      this.selectedItems = [];
      this.totalAmount = 0;

      this.sdsDetails.items = this.sdsDetails.items.map((item) => {
        return {
          ...item,
          enabled: false,
          disableItem: !item.required
        };
      });

      this.$emit("updateSdsDetails", { sdsOrderItems: this.selectedItems, totalAmount: this.totalAmount });
    },

    setDefaults() {
      // setting group 1 required item to be auto selected (Seller disclosure statement)
      if (this.groupSds && this.groupSds.length) {
        this.groupSds = this.groupSds.map((item, index) => {
          const updatedItem = {
            ...item,
            enabled: item.required || item.defaultSelected,
            disableItem: ["directOrder", "topUp"].includes(this.displayType) ? item.required : !item.required
          };

          // Manually call validateItems if it's enabled by default to set data in parent component
          if (updatedItem.enabled) {
            this.$nextTick(() => {
              this.validateItems(index, item.group);
            });
          }

          return updatedItem;
        });
      }
    },

    async validateItems(itemIndex, group = 1) {
      let disableItems = false;
      let requiredItemIndex = 0;
      this.selectedItems = [];
      this.totalAmount = 0; // this resets values as this function is called twice so prevents from doubling amount
      const orderItems = (group == 1) ? this.groupSds : this.groupConveyancing;

      orderItems.map((item, index) => {
        if (item.required && !item.enabled) {
          requiredItemIndex = index;
          disableItems = true; // If required item/option is not selected, disable all other options
        }

        if (!item.required && disableItems) {
          item.disableItem = true;
          item.enabled = false;
        } else if (!item.required && !disableItems) {
          item.disableItem = false;

          // If required item/option is selected/clicked, auto select option that has been tagged as "defaultSelected" true
          if ((itemIndex == requiredItemIndex) && item.defaultSelected) {
            item.enabled = true;
          }
        }

        if (item.enabled) {
          this.selectedItems.push(item.name);
          this.totalAmount += parseFloat(item.cost);
        }
      });

      this.$emit("updateSdsDetails", { sdsOrderItems: this.selectedItems, totalAmount: this.totalAmount });
    },

    handleServiceChange(type = "sds") {
      // sds => group = 1, conveyancing => group = 2
      if (type == "sds") {
        // disable all items from group 2 (conveyancing)
        this.groupConveyancing = this.groupConveyancing.map((item, index) => {
          const updatedItem = {
            ...item,
            enabled: false,
            disableItem: !item.required
          };

          return updatedItem;
        });

        // set group 1 defaults
        this.setDefaults();
      } else if (type == "conveyancing") {
        // disable all items from group 1 (sds)
        this.groupSds = this.groupSds.map((item, index) => {
          const updatedItem = {
            ...item,
            enabled: false,
            disableItem: !item.required
          };

          return updatedItem;
        });

        // enable required item from group 2 (conveyancing)
        this.groupConveyancing = this.groupConveyancing.map((item, index) => {
          const updatedItem = {
            ...item,
            enabled: item.required || item.defaultSelected,
            disableItem: !item.required
          };

          // Manually call validateItems if it's enabled by default to set data in parent component
          if (updatedItem.enabled) {
            this.$nextTick(() => {
              this.validateItems(index, item.group);
            });
          }

          return updatedItem;
        });
      }

      this.selectedGroup = type;
      this.totalAmount = 0;
    }
  },

  async created() {
    if (process.env.VUE_APP_NAME.toLowerCase().includes("rello")) {
      await this.getSellerDisclosureStatementSetting();
    }
  },

  computed: {
    displayCardWarning() {
      return (Array.isArray(this.sdsOrders) && this.sdsOrders.some(item => item.status !== "Cancelled"));
    }
  }
};
</script>

<style scoped>
/* Deep selector to override internal Vuesax styles to align cost to right */
::v-deep .con-slot-label, ::v-deep .vs-radio--label {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.item-label-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.con-vs-checkbox,
.con-vs-radio  {
  display: flex !important;
  align-items: flex-start !important;
}
</style>
